(function () {
  'use strict';

  if (window.BundleOrderAttribution) return;

  var ATTRIBUTES = {
    bundle_entry_source: 'custom_bundle',
    bundle_entry_location: 'product_page_bundle_builder'
  };
  var syncTimer = null;
  var requestQueue = Promise.resolve();

  function shopRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
  }

  function requestJSON(path, options) {
    return fetch(shopRoot() + path, options).then(function (response) {
      if (!response.ok) throw new Error('Bundle attribution request failed');
      return response.json();
    });
  }

  function updateAttributes(attributes, keepalive) {
    requestQueue = requestQueue.catch(function () {}).then(function () {
      return requestJSON('cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        keepalive: keepalive === true,
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ attributes: attributes })
      });
    });
    return requestQueue;
  }

  function fetchCart() {
    return requestJSON('cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });
  }

  function hasBundleLine(cart) {
    return !!(cart && Array.isArray(cart.items) && cart.items.some(function (item) {
      return item && item.properties && item.properties._bundle_id;
    }));
  }

  function hasAttribution(cart) {
    var attributes = cart && cart.attributes || {};
    return !!(attributes.bundle_entry_source || attributes.bundle_entry_location);
  }

  function mark() {
    return updateAttributes(ATTRIBUTES).catch(function () { return false; });
  }

  function clear(keepalive) {
    return updateAttributes({
      bundle_entry_source: '',
      bundle_entry_location: ''
    }, keepalive).catch(function () { return false; });
  }

  function sync(cart) {
    var cartPromise = cart ? Promise.resolve(cart) : fetchCart();
    return cartPromise.then(function (currentCart) {
      if (hasBundleLine(currentCart)) {
        return hasAttribution(currentCart) ? currentCart : mark();
      }
      return hasAttribution(currentCart) ? clear() : currentCart;
    }).catch(function () { return false; });
  }

  function scheduleSync(cart) {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(function () {
      sync(cart);
    }, cart ? 0 : 120);
  }

  window.BundleOrderAttribution = {
    mark: mark,
    sync: sync
  };

  document.addEventListener('cart:updated', function (event) {
    scheduleSync(event.detail && event.detail.cart);
  });
  document.addEventListener('shopify:cart:updated', function (event) {
    scheduleSync(event.detail && event.detail.cart);
  });
  document.addEventListener('cart:build', function () {
    scheduleSync();
  });
  document.addEventListener('ajaxProduct:added', function () {
    scheduleSync();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scheduleSync(); }, { once: true });
  } else {
    scheduleSync();
  }
})();
